import { Grid, makeStyles, Slider } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { ISelectAllergens, ISelectFoodCategory } from '../../interface/interface';
import { IDefaultDishContent } from '../../planEatApi/PlanEatFacade';
import { AllergenButton } from '../ui/AllergenButton';
import { CategoryCheckbox } from '../ui/CategoryCheckbox';
import { OfficeContext } from '../../config/Context';
import { allergensList } from '../../constants/allergens';
import { foodCategoriesList } from '../../constants/foodCategories';
import { sliderMarks } from '../../constants/sliderValues';
import { Modal } from '../ui/Modal';
import { InputContainer } from '../ui/InputContainer';
import { CancelCrudButtons } from '../ui/CancelCrudButtons';
import { InputField } from '../ui/InputField';

const useStyles = makeStyles((theme: any) => ({
    sliderContainer:{
        paddingTop: 40,
        display: 'grid',
        gridTemplateColumns: '100%',
        gridTemplateRow: '100%'
    },
    foodCategoryContainer:{
        display: 'grid',
        gridTemplateColumns: 'auto auto auto',
        gridTemplateRow: '100% 100%',
        columnGap: 15,
        rowGap: 15
    },
    inputTitle: {
        fontSize: 18,
        fontWeight: 700,
        paddingBottom: 15
    }
}));

interface Props {
    defaultMenuItemModalHidden:boolean;
    setDefaultMenuItemModalHidden:  React.Dispatch<React.SetStateAction<any>>;
    defaultMenuItem: IDefaultDishContent;
    setDefaultMenuItem:  React.Dispatch<React.SetStateAction<any>>;
    postDefaultMenuItem: () => void
}


export const DefaultMenuItemModal: React.FC<Props> = ({defaultMenuItemModalHidden,setDefaultMenuItemModalHidden,defaultMenuItem,setDefaultMenuItem,postDefaultMenuItem}) => {
    // Styling
    const classes = useStyles();

    // State
    const [allergensView, setAllergensView] = useState<any[]>([]);
    const [selectAllergens, setSelectAllergens] = useState<ISelectAllergens[]>([]);
    const [foodCategoryView, setFoodCategoryView] = useState<any[]>([]);
    const [selectFoodCategories, setSelectFoodCategories] = useState<ISelectFoodCategory[]>([]);

    const officeContext = useContext(OfficeContext);  

    useEffect(() => {
        if(officeContext?.office){
            checkIfDish()
        }
    },[officeContext?.office,defaultMenuItemModalHidden])

    const checkIfDish = () => {
        if(officeContext?.office){
            if(defaultMenuItem.defaultDishName !== ''){
                createSelectAllergens(defaultMenuItem);
                createSelectFoodCategories(defaultMenuItem);
            } else{
                createSelectAllergens();
                createSelectFoodCategories();
            }
        }
    }
    
    const createSelectAllergens = (defaultMenuItem ?: IDefaultDishContent) => {
        const tmpSelectAllergens : ISelectAllergens[] = []
        var selected = false;
        if(defaultMenuItem){
            for(let i=0;i<allergensList.length;i++){
                selected = false;
                defaultMenuItem.defaultDishAllergens.forEach((allergen) =>{
                    if(allergen=== allergensList[i]){
                        selected = true;
                    }
                })
                const tmpSelectAllergen : ISelectAllergens ={
                    'allergen' : allergensList[i],
                    'selected' : selected
                }
                tmpSelectAllergens.push(tmpSelectAllergen)
            }
        } else{
            for(let i=0;i<allergensList.length;i++){
                const tmpSelectAllergen : ISelectAllergens ={
                    'allergen' : allergensList[i],
                    'selected' : false
                }
                tmpSelectAllergens.push(tmpSelectAllergen)
            }
        }
        setSelectAllergens(tmpSelectAllergens)
    }

    const createSelectFoodCategories = (defaultMenuItem ?: IDefaultDishContent) => {
        const tmpSelectFoodCategories : ISelectFoodCategory[] = []
        var selected = false;

        if(defaultMenuItem){
            for(let i=0;i<foodCategoriesList.length;i++){
                selected = false;
                defaultMenuItem.defaultDishFoodCategories.forEach((foodCategory) =>{
                    if(foodCategory=== foodCategoriesList[i]){
                        selected = true;
                    }
                })
                const tmpSelectFoodCategory : ISelectFoodCategory ={
                    'foodCategory' : foodCategoriesList[i],
                    'selected' : selected
                }
                tmpSelectFoodCategories.push(tmpSelectFoodCategory)
            }
        } else{
            for(let i=0;i<foodCategoriesList.length;i++){
                const tmpSelectFoodCategory : ISelectFoodCategory ={
                    'foodCategory' : foodCategoriesList[i],
                    'selected' : false
                }
                tmpSelectFoodCategories.push(tmpSelectFoodCategory)
            }
        }
        setSelectFoodCategories(tmpSelectFoodCategories)
    }

    useEffect(() => {
        if(selectAllergens.length > 0){
            displayAllergens()
        }
    },[selectAllergens])
    
    const displayAllergens = () => {
        const tmpAllergens = allergensList.map((allergens,index) => (
            <AllergenButton 
                index={index+1}
                selectAllergen={allergens}
                selectAllergens={selectAllergens}
                selected={selectAllergens[index].selected}
                setSelectAllergens={setSelectAllergens}
            /> 
        ));
        setAllergensView(tmpAllergens);
    }

    useEffect(() => {
        if(selectFoodCategories.length > 0){
            displayFoodCategories()
        }
    },[selectFoodCategories])

    const displayFoodCategories = () => {
        const tmpFoodCategories = foodCategoriesList.map((foodCategory,index) => (
            <CategoryCheckbox 
                foodCategory={foodCategory}
                selectCategories={selectFoodCategories}
                selected={selectFoodCategories[index].selected}
                setSelectFoodCategories={setSelectFoodCategories}
            />
        ));
        setFoodCategoryView(tmpFoodCategories);
    }

    const handleChange = (prop: keyof IDefaultDishContent) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setDefaultMenuItem({ ...defaultMenuItem, [prop]: event.target.value });
    };

    const postDishElements = async () => {
        let selectedAllergens : string[] = [];
        for(let i=0;i<selectAllergens.length;i++){
            if(selectAllergens[i].selected){
                selectedAllergens.push(selectAllergens[i].allergen)
            }
        }

        let selectedFoodcategories : string[] = [];
        for(let i=0;i<selectFoodCategories.length;i++){
            if(selectFoodCategories[i].selected){
                selectedFoodcategories.push(selectFoodCategories[i].foodCategory)
            }
        }

        if(defaultMenuItem){
            defaultMenuItem.defaultDishAllergens = selectedAllergens;
            defaultMenuItem.defaultDishFoodCategories = selectedFoodcategories;
        }
        postDefaultMenuItem()
    };

    const resetCategories = () => {
        var tmpAllergens = [];
        var tmpFoodCategories = [];

        for(let i=0;i<selectAllergens.length;i++) {
            selectAllergens[i].selected = false;
            tmpAllergens.push(selectAllergens[i]);
        }
        for(let i=0;i<selectFoodCategories.length;i++) {
            selectFoodCategories[i].selected = false;
            tmpFoodCategories.push(selectFoodCategories[i]);
        }
        setSelectAllergens(tmpAllergens);
        setSelectFoodCategories(tmpFoodCategories);
    }

    useEffect(()=>{
        if(defaultMenuItemModalHidden){
            resetCategories();
        }
    },[defaultMenuItemModalHidden])

    return (
        <Modal title={defaultMenuItem.defaultDishId !== '' ? "Update" : "New " + "default menu item"} hidden={defaultMenuItemModalHidden} setHidden={setDefaultMenuItemModalHidden}>
            <div>    
                <InputContainer>
                    <div>
                        <InputField
                            label={"Dish Title"}
                            variant="outlined"
                            multiline
                            minRows={4}
                            value={defaultMenuItem.defaultDishName}
                            onChange={handleChange('defaultDishName')}
                            fullWidth
                        />
                    </div>
                    <div>
                        <InputField
                            label={"Dish Description"}
                            variant="outlined"
                            multiline
                            minRows={4}
                            value={defaultMenuItem.defaultDishDescription}
                            onChange={handleChange('defaultDishDescription')}
                            fullWidth
                        />
                    </div>
                    <div>
                        <div className={classes.inputTitle}>Categories</div>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            className={classes.foodCategoryContainer}
                        >
                            {foodCategoryView}
                        </Grid>
                    </div>
                    <div>
                        <div className={classes.inputTitle}>Allergens</div>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                        >
                            {allergensView}
                        </Grid>
                    </div>
                </InputContainer>
                <div className={classes.sliderContainer}>
                    <div className={classes.inputTitle}>CO-2 impact</div>
                    <Slider
                        aria-label="CO2_slider"
                        defaultValue={3}
                        step={1}
                        min={1}
                        max={5}
                        marks={sliderMarks}
                        valueLabelDisplay="auto"
                    />
                </div>
                <CancelCrudButtons 
                    hidden={defaultMenuItemModalHidden} 
                    setHidden={setDefaultMenuItemModalHidden} 
                    isDelete={false} 
                    postEntity={postDishElements}
                    postButtonText={defaultMenuItem.defaultDishId !== '' ? "Update default menu item" : "Create default menu item"}/>
            </div>
        </Modal>
    );
}